import './titleBar.css';

import titleBannerImage from '../../assets/images/trvto_calendar.png';
import titleBannerTile from '../../assets/images/trvto_titleBanner.svg';

const TitleBar = ({ title, className = '', image }) => {
    const { id } = JSON.parse(localStorage.getItem('tempOrg')) || {};
    return (
        <div className={`hideOnPrint titleBanner alignCenter ${className} ${id ? 'customHeader' : ''}`}>
            <div className='alignCenter gap-2'>
                {image && (
                    <div className='package-card'>
                        <img src={image} alt={title} />
                    </div>
                )}
                <p className='title'>{title}</p>
            </div>
            <img className='titleBannerPiece' src={titleBannerTile} alt='trvto_tile' />
            <img className='titleBannerImage' src={titleBannerImage} alt='trvto_calendar' />
        </div>
    );
};

export default TitleBar;
